import React, { Component } from 'react';
import createHistory from 'history/createHashHistory';
import $ from 'jquery';

import evn from "./../../../../../actions/index";//action的所有事件
import { connect } from "react-redux";//联系store的组件
import CaseDetailsInfoModal from "./../../../Common/CaseDetailsInfoModal";//登记单详情
import EventSet from "./../../../../../assets/PubJs/hcPub";//公用的所有事件
import Crumbs from './../../../Crumbs/Crumbs';
import companyCase from "./../../../../../assets/images/companyCase.png";
import zhCN from 'antd/lib/locale-provider/zh_CN';
import "./../style.css";
import { Form, Row, Col, Input, Button, Table, LocaleProvider, Modal, message, Checkbox,Select } from 'antd';
import { Hcurl } from "./../../../../../constants/index";//获取公共路径
const FormItem = Form.Item;
const history = createHistory();
const { confirm } = Modal;
//var localValue = JSON.parse(localStorage.getItem('userInfo'));

//var webUrl = 'http://211.149.250.2:20001/wisdom315_BusinessAPI/api/Business/';
//选择企业弹框
const data = [];
let _CompanyModalList = null;
let companyCode = '';
var values = {};
class CompanyModalList extends React.Component {
    state = {
        visible: false,
        selectedRowKeys: [],
        loading: false,
        data: [],
        value: [],
        allChecked: false,
        dataCheck: [],//企业多选框
        saveValue: [],
        companyCode: "",
        disabled: true
    }
    componentDidMount() {
        _CompanyModalList = this;
    }
    //设置用户选择的企业
    UserDefaultCompanys = () => {
        $.ajax({
            url: Hcurl + "/Business/SetUserDefaultCompanys?CU_Code=" + EventSet.getUserInfo().CU_Code + "&CU_ComCode=" + companyCode + '&Type=' + 0,
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                //console.log(data, companyCode, '用户设置选择的企业');
                if (data == 'True') {
                    _companyList.tableData();
                }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                //console.log(data)
            }
        })

    }
    handleOk = () => {  //弹框确定
        this.setState({
            loading: true,
            visible: false,
        })
        //console.log(this.state.value, 'this.state.value');
        this.setState({
            saveValue: this.state.value
        })
        setTimeout(() => {
            let stateValue = this.state.saveValue;
            if (this.state.value.length != 0) {
                let companyName = '';
                for (var i = 0; i < stateValue.length; i++) {
                    companyName += stateValue[i].split(',')[1] + ' ; '
                    companyCode += stateValue[i].split(',')[0] + ','
                }
                companyCode = companyCode.substring(0, companyCode.length - 1);
                companyName = companyName.substring(0, companyName.length - 2);
                _companyList.setState({
                    companyAllList: companyName,
                    companyList: 1,
                    span: 22,
                });

            } else {
                _companyList.GetSelectCompany();
                this.setState({
                    value: []
                })
                _companyList.setState({
                    companyList: 0,
                    span: 24
                })
            }
            _CompanyModalList.UserDefaultCompanys();
            //console.log(companyCode, 'companyCode34324')
        }, 20)
        setTimeout(() => {
            _CompanyModalList.setState({
                loading: false
            })
        }, 200);
        //console.log(companyCode, 'companyCode104');
        companyCode = "";
    }
    handleCancel = () => {
        this.setState({
            visible: false
        })
    }
    onChange = (value) => {  //点击单个多选框方法
        if (value.length === 0) {
            this.setState({
                disabled: true
            })
        } else {
            this.setState({
                disabled: false
            })
        }
        this.setState({ value, allChecked: value.length === data.length });
    }
    handleCheckAll = (e) => {  //全选
        //console.log(e.target.checked)
        const checked = e.target.checked
        this.setState({ allChecked: checked })
        //if (checked) {
        this.setState({
            value: this.state.dataCheck.map(item => item.Com_CodeAndName),
            disabled: false
        })
        //companyCode = this.state.dataCheck.map(item => item.Com_Code)
        ////console.log(companyCode,'companyCodecompanyCode')
        //}
        setTimeout(() => {
            //console.log(this.state.value);
        }, 20)

    }
    isInArray = (arr, value) => {
        var arrary = [];
        //console.log(value, 'value');
        for (var i = 0; i < arr.length; i++) {
            if (value.indexOf(arr[i].Com_CodeAndName) < 0) {
                arrary.push(arr[i].Com_CodeAndName);
                //console.log(arr[i].Com_CodeAndName, '20')
            } else {
                //console.log(arr[i].Com_CodeAndName, '33333')
            }
        }
        //console.log(arrary, '20000000');
        this.setState({
            value: arrary
        })
    }
    handleCheckAll2 = (e) => {  //反选
        this.setState({
            allChecked: false,
        })
        //this.setState({ value: [] });

        if (this.state.value.length !== 0) {
            if (this.state.value.length == this.state.dataCheck.length) {
                this.setState({ value: [] });
            } else {
                this.isInArray(this.state.dataCheck, this.state.value)
            }

        }
        setTimeout(() => {
            if (_CompanyModalList.state.value.length === 0) {
                _CompanyModalList.setState({
                    disabled: true
                })
            } else {
                _CompanyModalList.setState({
                    disabled: false
                })
            }
            //console.log(this.state.value, '反选');
        }, 20)
    }

    render() {
        return (
            <div style={{ width: 1000 }}>
                <Modal
                    title="选择企业"
                    width={600}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    loading={this.state.loading}
                    maskClosable={false}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loading} onClick={this.handleOk}>
                            确定
                        </Button>,
                    ]}
                >
                    <div className='LModalList' id='LocaleProvider'>
                        <div style={{ marginBottom: 10 }}>请选择下方企业条目</div>
                        <Checkbox onChange={this.handleCheckAll} checked={this.state.allChecked} style={{ marginRight: 10 }}>全选</Checkbox>
                        <Checkbox onChange={this.handleCheckAll2} checked={this.state.allChecked} disabled={this.state.disabled}>反选</Checkbox>
                        <div className='LCheckbox2 LCheckbox'>
                            <Checkbox.Group onChange={this.onChange} value={this.state.value}>
                                {
                                    this.state.dataCheck.map(item => <div key={item.Com_Code} className='div'>
                                        <Checkbox value={item.Com_CodeAndName} style={{ width: '100%' }} className='Lli' id={item.Com_Code}>{(item.Com_Name).length >= 26 ? (item.Com_Name).substring(0, 26) + '...' : item.Com_Name}</Checkbox>
                                    </div>)
                                }
                            </Checkbox.Group>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}
//表格
var _this = this;
class TableWaper extends Component {
    state = {
        data: [], //数据源
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            total: 0
        },
        loading: false,
        pagetotalCount: 0,
        display: 'none',
        companyList: "",
        _record: "",
        sorters: 'CP_Time desc'

    }

    handleTableChange = (pagination, filters, sorter) => {
        //console.log(pagination, filters)
        ////console.log(filters[6].toString(), '332')
        this.setState({
            pagination: pagination,
        });
        //console.log(Object.keys(filters).length == 0);
        if (Object.keys(filters).length !== 0) {
            _companyList.setState({
                filters: filters.CP_Result.toString()
            })
        }
        if (Object.keys(sorter).length !== 0) {

            
            if (sorter.field == "CP_Time"&& sorter.order!=undefined ) {
                _this.setState({
                    sorters: sorter.order == 'descend' ? "CP_Time desc" : "CP_Time"
                })
            }else if(sorter.field == "CP_Time"&& sorter.order==undefined){
                _this.setState({
                    sorters:  "CP_Time desc" 
                })
            }
        }
        setTimeout(function () {
            _companyList.tableData()
        }, 20)
    };

    componentWillMount() {

    }

    componentDidMount() {

        _this = this;
    }

    Correction = (record) => {

        let url = window.location.href.split("#")[0] + "#/New/CompormiseCorrection?CI_Code=" + record.CI_Code + ' &CP_Result=' + record.CP_Result + "&ComCode=" + record.CP_ComCode;
        window.open(url)


        //history.push({
        //    pathname: './New/CompormiseCorrection?CI_Code=' + record.CI_Code + '&CP_Result=' + record.CP_Result + "&ComCode=" + record.CI_DealDeapartCode
        //})
        //console.log(record)
    }
    recordCheck=(record)=>{
        $.ajax({
            url: Hcurl + '/Business/AddViewLog',
            type: "post",
            data: {
                CI_Code: record.CI_Code,
                UserCode: EventSet.getUserInfo().CU_Code,//当前登录人Code
                UserName: EventSet.getUserInfo().userName,//当前登录人名称
            },
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
              
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
    }
    //点击显示登记编号弹框
    ModalCase = (record) => {
        //this.setState({
        //    visible: true,
        //    _record: record
        //})
        this.recordCheck(record)
        _companyList.props.dispatch(evn.showCaseInfo(record.ID, 'CompanyHasDealt'))
    }
    //点击关闭登记编号弹框
    handleOk = (e) => {
        this.setState({
            visible: false,
        });
    }
    UnCorrection = () => {
        message.warn('权限不足，只有管理员可更改！')
    }
    withdraw=(record)=>{
        confirm({
            title: '撤回审批',
            content: '撤回审批后，您可以对当前工单重新办结。确定要撤回审批操作吗？',
            okText:'确定',
            cancelText:'取消',
            onOk() {
                $.ajax({
                    url: Hcurl + '/Business/CancelAppeFeedApprove',
                    type: "post",
                    headers: {
                        "token": EventSet.getUserInfo()['token']
                    },
                    data:{
                        CI_Code :record.CI_Code,
                        UserCode  :EventSet.getUserInfo()['CU_Code'],
                        UserName  :EventSet.getUserInfo()['userName'],
                        ComCode  :record.CP_ComCode,
                        ComName  :EventSet.getUserInfo()['XXHJCom_Name'],
                    },
                    success: function (data) {
                      console.log(data)
                      if(data.indexOf('true')>-1){
                        message.success(data.split('|')[1])
                        _companyList.tableData()
                      }else{
                        message.error(data.split('|')[1])
                      }
                      
                    },
                    error: function (data) {
                        history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                        //console.log(data)
                    }
                })
            },
            onCancel() {},
          });
    }
    render() {
        const { pagetotalCount, pagination } = this.state
        this.columns = [
            {
                title: '登记编号',
                width: 270,
                fixed: 'left',
                key: "1",
                render: (text, record, index) => {
                    return (
                        <div>
                            <a style={{ marginRight: 10 }} onClick={v => this.ModalCase(record)}>{record.CI_Code}</a>
                        </div>
                    )
                }
            },
            {
                title: '信息类别',
                dataIndex: 'CI_Type',
                key: "11",
            },
            {
                title: '投诉人姓名',
                dataIndex: 'CI_UserName',
                key: "2",
            },
            {
                title: '联系电话',
                dataIndex: 'CI_UserPhone',
                width:150,
                key: "3",
            },
            {
                title: '商品/服务名称',
                dataIndex: 'CI_ShopName',

                key: "4",

            }, {
                title: '办理时间',
                dataIndex: 'CP_Time',
                sorter: true,
                key: "5",
                width:180
            },
            {
                title: '办理结果',
                width: 150,
                fixed: 'right',
                dataIndex: 'CP_Result',
                filters: [
                    { text: '和解成功', value: '和解成功' },
                    { text: '和解失败', value: '和解失败' },
                    { text: '拒绝和解', value: '拒绝和解' },
                ],

            },
            {
                width: 120,
                title: '操作',
                fixed: 'right',
                render: (text, record, index) => {
                    return (
                        <div>
                            {record.CP_Result === '拒绝和解' || record.CI_SubState == '待审批'? <a style={{ color: "#ccc" }}>更正</a> : (record.UCR_ComUserID === EventSet.getUserInfo().CU_Code) ? <a onClick={() => this.Correction(record)}>更正</a> : <a onClick={() => this.UnCorrection(record)}>更正</a>}
                            {record.CI_SubState=='待审批'?<a style={{marginLeft:'10px'}} onClick={()=>this.withdraw(record)}>审批撤回</a>:''}
                        </div>
                    )
                },
                key: "7"
            }];

        return (
            <div style={{ position: "relative" }}>

                <Modal
                    width='1000px'
                    title="查看"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    maskClosable={false}
                    footer={[
                        <Button key="submit" onClick={this.handleOk}>
                            返回列表
                         </Button>,

                    ]}
                >

                </Modal>
                <LocaleProvider locale={zhCN}>
                    <Table
                        columns={this.columns}
                        dataSource={this.state.data}
                        rowKey={record => record.ID}
                        onChange={this.handleTableChange}
                        pagination={this.state.pagination}
                        loading={this.state.loading}
                        size="middle"
                        scroll={{ x: 1200 }}
                        bordered
                    />
                </LocaleProvider>
                <span className='tableTotal' style={{ display: this.state.display }}>共 {pagetotalCount} 条记录 第 {pagination.current} / {pagination.total % pagination.pageSize == 0 ? Math.floor(pagination.total / pagination.pageSize) : Math.floor(pagination.total / pagination.pageSize) + 1} 页</span>
            </div>
        )
    }
}
var _companyList = null;
var ValueArray = [{
    Code: "",
    UserName: "",
    UserPhone: "",
    infoClass:"",
}]
class App extends Component {
    state = {
        autoHeight: "",
        companyList: 0,//没有选择企业
        filters: "",//办理结果查询
        //_isMounted: false
    }
    autoHeight = () => {  //内容区域高度自适应
        let autoHeight = window.innerHeight - 429;
        this.setState({
            autoHeight: autoHeight
        })
    }
    chooseCompany = () => {  //选择企业
        _companyList.chooseCompanyPrv();
        //companyCode = '';
        _CompanyModalList.setState({
            visible: true,
        });
        _CompanyModalList.setState({
            value: _CompanyModalList.state.saveValue
        })
        if (_CompanyModalList.state.saveValue.length > 0) {
            _CompanyModalList.setState({
                disabled: false
            })
        } else {
            _CompanyModalList.setState({
                disabled: true
            })
        }
        //console.log(_CompanyModalList.state.value, _CompanyModalList.state.allChecked)
    }

    //获取到的所有企业
    GetSelectCompany = () => {
        $.ajax({
            url: Hcurl + '/Business/GetSelectCompany?UserCode=' + EventSet.getUserInfo().CU_Code + '&Type=' + 2,
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                if (data != null && data != []) {
                    data = JSON.parse(data)
                    //console.log(data, '获取到的所有企业');
                    _CompanyModalList.setState({
                        dataCheck: data
                    });
                    companyCode = data.map(function (ds) {
                        return ds.Com_Code
                    })
                    companyCode = companyCode.toString();

                    _CompanyModalList.setState({
                        companyCode
                    })

                    setTimeout(() => {
                        //console.log(companyCode, 'companyCode1231232')
                        _companyList.tableData()
                    }, 20)
                }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                //console.log(data)
            }
        })

    }
    //获取用户上次选择的企业
    chooseCompanyPrv = () => {
        $.ajax({
            url: Hcurl + '/Business/GetUserDefaultCompanys?CU_Code=' + EventSet.getUserInfo().CU_Code + '&Type=' + "0",
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                //console.log(data, '已反馈');
                if (data != null && data != '') {
                    //console.log(data,'data');
                    if (data.split('|')[0] !== 'false' && data != 0) {
                        data = JSON.parse(data);
                        //console.log(data, '获取用户上次选择的企业1');
                        companyCode = data.map(function (ds) {
                            return ds.Com_Code;
                        })
                        //console.log(companyCode.toString(), 'companyCode上次获取的companyCode');
                        companyCode = companyCode.toString();
                        let companyAllList = data.map(function (ds) {
                            return ds.Com_Name
                        })
                        _companyList.setState({
                            companyAllList: companyAllList.toString().replace(/,/g, ' ; '),
                            companyList: 1,
                            span: 22,
                        })
                        _CompanyModalList.setState({
                            saveValue: data.map(function (item, idx) {
                                return data[idx].Com_CodeAndName
                            }),
                        })
                        setTimeout(() => {
                            //console.log(434)
                            $.ajax({
                                url: Hcurl + '/Business/GetSelectCompany?UserCode=' + EventSet.getUserInfo().CU_Code + '&Type=' + 2,
                                type: "get",
                                headers: {
                                    "token": EventSet.getUserInfo()['token']
                                },
                                success: function (data) {
                                    if (data != null && data != []) {
                                        data = JSON.parse(data)
                                        //console.log(data, '获取到的所有企业');
                                        _CompanyModalList.setState({
                                            dataCheck: data
                                        });

                                        setTimeout(() => {
                                            _companyList.tableData()
                                        }, 20)
                                    }
                                },
                                error: function (data) {
                                    history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                                    //console.log(data)
                                }
                            })


                            //_companyList.GetSelectCompany()
                        }, 20);

                    } else {
                        //console.log(439)
                        _companyList.GetSelectCompany()

                    }
                }
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
    }
    tableData = () => {
        _this.setState({ loading: true });
        const pagination = { ..._this.state.pagination };
        $.ajax({
            url: Hcurl + '/Business/GetCompanyAlreadyHandled',
            type: "post",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            data: {
                UserCode: EventSet.getUserInfo().CU_Code,
                CI_Code: ValueArray[0].Code,
                CI_UserName: ValueArray[0].UserName,
                CI_UserPhone: ValueArray[0].UserPhone,
                CI_Type: ValueArray[0].infoClass,
                ComCode:  EventSet.getUserInfo().xxhjcompanycode,
                CP_Result: _companyList.state.filters,
                pageNo: pagination.current,
                pageSize: pagination.pageSize,
                //CI_RegTime: _this.state.sorters,
                order: _this.state.sorters
            },
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (data) {
                if (data !== "" && data !== null&& data !== 'null') {
                    //console.log(data)
                    _this.setState({
                        data: data.Table,
                        pagetotalCount: data.Table1[0].Column1,
                        pagination: pagination,
                    })
                    if (data.Table.length !== 0) {
                        _this.setState({
                            display: "block",
                        })
                    } else {
                        _this.setState({
                            display: "none",
                        })
                    }
                    pagination.total = data.Table1[0].Column1;
                }

                _this.setState({
                    loading: false,
                })
            },
            error: function (res) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                //console.log(res);
            }
        })
    }
    //查询调解搜索方法
    handleSearch = () => {
        const { form } = this.props;
        form.validateFields((err, fieldsValue) => {
            values = {
                ...fieldsValue,
            };
            ValueArray[0].Code = values.Code;
            ValueArray[0].UserName = values.Name;
            ValueArray[0].UserPhone = values.Phone;
            ValueArray[0].infoClass = values.infoClass;
            
            const pagination = { ..._this.state.pagination };
            pagination.current = 1;
            _this.setState({
                pagination: pagination
            })
            setTimeout(function () {
                _companyList.tableData();
            }, 20)

        })
    }
    //重置搜索调解
    reSet = () => {
        this.props.form.resetFields();
    }
    //组件加载完成后
    componentDidMount() {
        //this.setState({
        //    _isMounted: true
        //})
        ValueArray = [{
            Code: "",
            UserName: "",
            UserPhone: "",
            infoClass:"",
        }]
        _companyList = this;
        this.autoHeight();
        this.chooseCompanyPrv();
        EventSet.NavShow(this, "/Content/Business/CompormiseListAlready", "Compromise")//显示菜单
    }
    componentWillUnmount() {

    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { autoHeight } = this.state;
        const formItemLayout = {
            labelCol: {
                xxl: { span: 4 },
                xl: { span: 6 },
                lg: { span: 8 },
                md: { span: 10 },
            },
            wrapperCol: {
                xxl: { span: 18 },
                xl: { span: 16 },
                lg: { span: 14 },
                md: { span: 10 },
            }
        };
        const style = {
            minHeight: autoHeight
        };
        const style1 = {
            marginRight: 25,
        };
        return (
            <div id='Company'>
                <Crumbs title={"先行和解 / 已处理"} />
                <CaseDetailsInfoModal />
                <CompanyModalList />
                <div className={'Company'} style={style}>
                    <Form onSubmit={this.handleSubmit} className='formSearch'>
                        <Row>
                            <Col span={8}>
                                <FormItem
                                    label="登记编号"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('Code')(
                                        <Input placeholder='请输入登记编号' />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    label="投诉人姓名"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('Name')(
                                        <Input placeholder='请输入投诉人姓名' />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    label="投诉人电话"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('Phone')(
                                        <Input placeholder='请输入投诉人电话' />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={8}>
                                <FormItem
                                    label="信息类别"
                                    {...formItemLayout}
                                >
                                    {getFieldDecorator('infoClass',{initialValue:''})(
                                        <Select placeholder='请选择信息类别'>
                                        <Option key={1} value="">全部</Option>
                                        <Option key={2} value="投诉">投诉</Option>
                                        <Option key={3} value="无理由退货">无理由退货</Option>
                                      </Select>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={16}>
                            <div className='searchBtn'>
                            <span className='searchSpan'>
                                <Button type="primary" htmlType="submit" style={style1} onClick={this.handleSearch}>搜索</Button>
                                <Button type="" onClick={this.reSet}>重置</Button>
                            </span>
                            </div>
                            </Col>
                          
                        </Row>
                      
                    </Form>
                    <div style={{ width: "95%", margin: "0 auto" }}>
                        {/* <div style={{ marginTop: 30}}>
                            <Row>
                                <Col span={24}>
                                    <div className='AlertInfo'>
                                        <img src={companyCase} className='imgCompanyCase' alt='图片' />
                                        {this.state.companyList === 0 ? <span className='hasSpan'>未选择任何企业</span> : <span className='hasSpan'>已选：<span style={{
                                            color: 'rgba(0, 0, 0, 0.647058823529412)', display: "inline-block", width: "80%", overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', position: "absolute"
                                        }} title={this.state.companyAllList}>{this.state.companyAllList}</span></span>}
                                        <div className='chooseCompany' onClick={this.chooseCompany}>选择企业</div>
                                    </div>
                                </Col>
                            </Row>
                        </div> */}
                        <div className='TableWaper'>
                            <TableWaper />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}
const CompanyHasDealtWrap = Form.create()(App);



export default connect()(CompanyHasDealtWrap)


// WEBPACK FOOTER //
// ./src/components/Content/Business/CompormiseListAlready/CompormiseListAlready/CompormiseListAlready.js